import { defineMessages } from 'react-intl';

const messages = defineMessages({
  description: {
    id: 'profiles.accountPage.description',
    defaultMessage: 'Personal profile',
  },
  joined: {
    id: 'profiles.accountPage.joined',
    defaultMessage: 'Joined {date}',
  },
  publicPageSectionTitle: {
    id: 'profiles.accountPage.publicPageSectionTitle',
    defaultMessage: 'Public page — {organizationName}',
  },
  sectionProfileTab: {
    id: 'profiles.accountPage.sectionProfileTab',
    defaultMessage: 'Profile',
  },
  sectionSubscriptionsTab: {
    id: 'profiles.accountPage.sectionSubscriptionsTab',
    defaultMessage: 'Subscriptions',
  },
  title: {
    id: 'profiles.accountPage.title',
    defaultMessage: 'Personal profile',
  },
  updateSuccess: {
    id: 'profiles.accountPage.updateSuccess',
    defaultMessage: 'Profile updated successfully.',
  },
});

export default messages;
